export const MICROSITE_PAGE_MODEL = "microsite-page";

const micrositePageModel = {
  micrositePageId: "",
  micrositeId: "",
  name: "",
  slug: "",
  content: "",
  displayOrder: 0,
  isLive: 0,
  microsite: {
    jsonApi: "hasOne",
    type: "microsites"
  }
};

export default micrositePageModel;
